import { Grid } from "@mui/material";
import ByzCard from "src/components/core-components/ByzCard";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMcParameterDetailRadio from "src/components/shared-components/ByzMcParameterDetailRadio";

interface FlaccScaleProps {
  t: (key: string) => string;
  cardData: any;
  selectedMCPs: Record<string, any>;
  handleMCPChange: (key: string, value: any) => void;
  getMCPParameterDetails: (id: number) => any;
  mcpCacheLoaded: boolean;
}

const FlaccScale: React.FC<FlaccScaleProps> = ({
  t,
  cardData,
  selectedMCPs,
  handleMCPChange,
  getMCPParameterDetails,
  mcpCacheLoaded,
}) => {
  return (
    <ByzCard sx={{ mt: 3, mb: 5 }}>
      <ByzTitleBox title={t("pain-assessment-scale.flacc-scale.title")} />

      <ByzCard sx={{ padding: 0, ml: 1, mb: 1 }}>
        {/* 1. Grup - Yüz İfadesi & Ağlama */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.flacc-scale.flacc-face-expression")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.FLACC_FACE_EXPRESSION.mcpId}
              value={selectedMCPs.FLACC_FACE_EXPRESSION}
              handleChange={(val) =>
                val && handleMCPChange("FLACC_FACE_EXPRESSION", val)
              }
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.FLACC_FACE_EXPRESSION.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.flacc-scale.flacc-legs")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.FLACC_LEGS.mcpId}
              value={selectedMCPs.FLACC_LEGS}
              handleChange={(val) => val && handleMCPChange("FLACC_LEGS", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.FLACC_LEGS.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>

        {/* 2. Grup - Solunum Şekli & Kollar */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.flacc-scale.flacc-activite")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.FLACC_ACTIVITE.mcpId}
              value={selectedMCPs.FLACC_ACTIVITE}
              handleChange={(val) =>
                val && handleMCPChange("FLACC_ACTIVITE", val)
              }
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.FLACC_ACTIVITE.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.flacc-scale.flacc-cry")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.FLACC_CRY.mcpId}
              value={selectedMCPs.FLACC_CRY}
              handleChange={(val) => val && handleMCPChange("FLACC_CRY", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.FLACC_CRY.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.flacc-scale.flacc-consolation")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.FLACC_CONSOLATION.mcpId}
              value={selectedMCPs.FLACC_CONSOLATION}
              handleChange={(val) => val && handleMCPChange("FLACC_CONSOLATION", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.FLACC_CONSOLATION.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>
      </ByzCard>

      {/* Skor Bilgisi */}
      <ByzCard sx={{ padding: 0, ml: 1, mt: 0 }}>
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>
              {
                "0 - Ağrı Yok , 1-3 Hafif Ağrı , 3-5 Orta Şiddetli Ağrı , >5 Şiddetli Ağrı "
              }
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>Skor : 1</ByzMuiTypography>
          </Grid>
        </Grid>
      </ByzCard>
    </ByzCard>
  );
};

export default FlaccScale;
